import CircularProgress from "@mui/material/CircularProgress";

import { useResourceContext } from "react-admin";

import * as S from "./styled";
import { getTextByLabelForResource } from "../helpers/getTextByLabelForResource";

interface Props<TResource> {
  importedResources: TResource[] | undefined;
}

export const ResourceReviewStep = <TResource,>({ importedResources }: Props<TResource>) => {
  const resource = useResourceContext();

  return (
    <S.DialogContentContainer>
      {importedResources ? (
        <>
          {importedResources.length} {getTextByLabelForResource(resource, "imported")}
        </>
      ) : (
        <S.SpinnerContainer>
          <CircularProgress />
        </S.SpinnerContainer>
      )}
    </S.DialogContentContainer>
  );
};
